import { render, staticRenderFns } from "./RecepcionRegistra.vue?vue&type=template&id=42ca03f3&"
import script from "./RecepcionRegistra.vue?vue&type=script&lang=js&"
export * from "./RecepcionRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports